import { create } from "zustand";

export default create((set) => {
  return {
    clickables: [
      "statue",
      "reader",
      "tavern",
      "musician",
      "stage",
      "flag",
      "boat",
      "route",
      "well",
    ],
    index: -1,
    phase: "ready",
    clicked: "",
    moving: false,
    help: false,
    restart: () => {
      set(() => {
        return { phase: "ready", index: -1, moving: false, clicked: "" };
      });
    },
    focus: () => {
      set(() => {
        return { phase: "focus" };
      });
    },
    story: () => {
      set(() => {
        return { phase: "story" };
      });
    },
    setIndex: (newIndex) => {
      set(() => {
        return { index: newIndex, moving: true };
      });
    },
    setMoving: (isMoving) => {
      set(() => {
        return { moving: isMoving };
      });
    },
    setObject: (name) => {
      set(() => {
        return { clicked: name };
      });
    },
    setHelp: (isOn) => {
      set(() => {
        return { help: isOn };
      });
    },
  };
});
